'use strict'; // TODO: Zone metrics

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var Base = require('./base');

var Zone = window.Zone;
var singleton = null;

var Scope =
/*#__PURE__*/
function (_Base) {
  _inherits(Scope, _Base);

  function Scope() {
    var _this;

    _classCallCheck(this, Scope);

    if (singleton) return _possibleConstructorReturn(_this, singleton);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scope).call(this));
    singleton = _assertThisInitialized(_this);
    return _this;
  }

  _createClass(Scope, [{
    key: "_active",
    value: function _active() {
      if (!Zone) return null;
      return Zone.current.get('_datadog_span');
    }
  }, {
    key: "_activate",
    value: function _activate(span, callback) {
      if (!Zone) return callback();
      var spec = {
        properties: {
          _datadog_span: span
        }
      };
      return Zone.current.fork(spec).run(function () {
        return callback();
      });
    }
  }]);

  return Scope;
}(Base);

module.exports = Scope;